export const FOLLOW_FEED_SUCCESS_SUBHEADING =
  "To help podcasters understand their audience, we share their followers' email addresses. If you prefer not to share yours, please unfollow this podcast.";

export const FOLLOW_FEED_NOTIFICATION_TIMING = 15000;
